export default __webpack_public_path__ + "static/media/ExcelIcon.2586a621.svg";